import { DateFieldStyle } from "./date-field.style";
import { Typography } from "@mui/material";
import { DateFieldProps } from "../common-types";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  LocalizationProvider,
  DatePicker,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";

const DateField = (props: DateFieldProps) => {
  const {
    name,
    label,
    value,
    error,
    disabled,
    className,
    onChange,
    helperText = null,
  } = props;
  return (
    <DateFieldStyle className={`${className || ""} field-wrapper`}>
      {label && <Typography className="field-label">{label}</Typography>}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          sx={{ width: "100%" }}
          value={value ? dayjs(String(value)) : null}
          onChange={onChange}
          disableFuture
          slotProps={{
            textField: {
              id: name,
              helperText: error?.message || helperText || null,
              disabled: disabled,
            },
          }}
        />
      </LocalizationProvider>
    </DateFieldStyle>
  );
};

export default DateField;
